import WSDataGrid from "../../Components/DataGrid/WSDataGrid";
import { Header } from "../../Components/Header/Header";
import { Grid, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { billingColumns, billingData } from "./data";
import { useState } from "react";
import { CreateBill } from "./GenerateBills";

export const BillingList = () => {
  // const [loading, setLoading] = useState<boolean>(true);
  const [data, setData] = useState<any[]>(billingData || []);
  const [filter, setFilter] = useState("all");
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleAddBill = (newBill: any) => {
    setData([...data, { id: data.length + 1, ...newBill }]);
  };

  // Handle Filter Change
  const handleFilterChange = (
    event: React.MouseEvent<HTMLElement>,
    newFilter: string
  ) => {
    if (newFilter) setFilter(newFilter);
  };

  // Filter Data Based on Selection
  const filteredData =
    filter === "all" ? data : data.filter((bill) => bill.status === filter);

  return (
    <>
      <Header
        type="simple"
        isDivider={true}
        title="Bills"
        id={"billHeader"}
        headerSx={{ marginTop: 0, backgroundColor: "#7D79C2", p: 1 }}
      />

      {/* <Grid container spacing={2} alignItems="center" mb={2}>
        <Grid item xs={6}>
          <ToggleButtonGroup
            value={filter}
            exclusive
            onChange={handleFilterChange}
            aria-label="billing status filter"
          >
            <ToggleButton value="all">All</ToggleButton>
            <ToggleButton value="paid">Paid</ToggleButton>
            <ToggleButton value="due">Due</ToggleButton>
          </ToggleButtonGroup>
        </Grid>
      </Grid> */}

      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <WSDataGrid
            id="BillGrid"
            title="Bills"
            columns={billingColumns}
            data={filteredData}
            addButton={{ label: "New", color: "secondary" }}
            onAddButtonClick={handleOpenModal}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke"
            }}
            exportCsv
          />
        </Grid>
      </Grid>

      <CreateBill open={openModal} onClose={handleCloseModal} onSave={handleAddBill} />
    </>
  );
};
